import React, {useEffect, useRef} from 'react';
// import logo from '../assets/images/logo.svg';
// import './styles/App.css';
import HomePage from "./pages/HomePage";
import Owner from "./models/Owner";
// import EventEmitter from "./events/EventEmitter";
// import LocaleChangedEvent from "./events/LocaleChangedEvent";
import {useForceFunctionComponentUpdate} from "./helpers/utils";
import {i18nInstance} from "./localization/core";


function App() {
  const forceUpdate = useForceFunctionComponentUpdate()

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      // @ts-ignore
      /*EventEmitter.instance.on(LocaleChangedEvent, event => {
        console.log('Locale Event emitted', event)
        forceUpdate()
      })*/

      i18nInstance.on('languageChanged', (locale: string) => {
        console.log('Locale Event emitted', locale)
        forceUpdate()
        window.history.pushState(null, 'lng_title', '/?lng=' + locale)
      });
    }
  })

  return (
    <div className="art-app">

      <div className="art-mobile-top-bar"/>

      <div className="art-app-wrapper">

        <div className="art-app-container">

          <HomePage/>

        </div>

      </div>

      {/* preloader */}
      <div className="art-preloader">
        {/* preloader content */}
        <div className="art-preloader-content">
          {/* title */}
          <h4>{Owner.instance.fullName}</h4>
          {/* progressbar */}
          <div id="preloader" className="art-preloader-load"/>
        </div>
        {/* preloader content end */}
      </div>
      {/* preloader end */}
    </div>
  )
}

export default App;
